<script lang="ts">
    import RelationshipsPage from '@Alternatives/AlternativesLists/Pages/RelationshipsPage'
    export default RelationshipsPage
</script>

<template>
    <div>
        <PortfolioOrDecisionNavigation :workspaceId="workspaceId" :projectId="projectId" />

        <div class="container" style="margin-top: 80px; padding-top: 40px;">
            <div class="row">
                <div class="col-lg-6">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">Dependencies</h1>
                </div>
                <div class="col-lg-6 text-right"></div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 60px;" />

        <div class="container" v-if="rm">
            <button class="btn btn-outline-secondary mr-1" @click="toggleViewBy">View by: {{ViewBy}}</button>
            <button class="btn btn-outline-secondary" @click="toggleFilter">Filter: {{Filter}}</button>
            <br /><br />

            <table class="table table-hover" v-if="ViewBy === 'Foundation'">
                <thead>
                    <tr>
                        <th>Foundation</th>
                        <th>Dependents</th>
                    </tr>
                </thead>

                <tbody v-for="f in FoundationsView" :key="f.AlternativeId">
                    <tr>
                        <td>
                            <a v-sanitizedHref="url_AlternativeDashboardPage(f.Id)">{{f.Name}}</a>
                        </td>
                        <td>
                            <span v-for="d in getDependents(f)" :key="d.Id">
                                <a v-sanitizedHref="url_AlternativeDashboardPage(d.Id)">{{d.Name}}</a>, 
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table class="table table-hover"  v-if="ViewBy === 'Dependent'">
                <thead>
                    <tr>
                        <th>Dependent</th>
                        <th>Foundations</th>
                        <th style="width: 100px;"></th>
                    </tr>
                </thead>
                <tbody v-for="d in DependentsView" :key="d.AlternativeId">
                    <tr>
                        <td>
                            <a v-sanitizedHref="url_AlternativeDashboardPage(d.Id)">{{d.Name}}</a>
                        </td>
                        <td>
                            <span v-for="f in getFoundations(d)" :key="f.Id">
                                <a v-sanitizedHref="url_AlternativeDashboardPage(f.Id)">{{f.Name}}</a>,
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

